<template>
  <h1 class="choice-title" :class="{
    required: $store.getters?.getQuesInfo?.type === 1 && info?.isRequired,
  }">
    <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
      `${quesIndex + 1}、`
    }}</span>
    {{ info?.title || '请上传' }}<span v-if="$store.getters?.isShowType" class="tips">(文件上传)</span>
  </h1>
  <div class="choice">
    <div class="choice-item" style="position: relative">
      <div class="upload-wrap">
        <Loading v-show="showLoading" />
        <div v-show="!showLoading" class="wrap-content">
          <img src="@/assets/img/icon-upload.png" />
          <p class="picker" :id="'picker' + quesIndex">选择文件</p>
        </div>
      </div>
    </div>
  </div>
  <p class="upload-tips">{{ maxSizeTips }}</p>
  <Progress v-if="showLoading" class="progress" :percentage="precent" />
  <div v-for="(item, index) in uploadList" :key="`${index}-${item.namne}`" class="upload-success choice">
    <Icon class="icon" name="completed" />
    <p class="success-text">{{ item.name }}</p>
    <Icon @click="handleFileListRemove(index)" class="close-icon" name="cross" />
  </div>
  <!-- 上传是图片的时候预览列表 -->
  <div class="preview-list">
    <div v-for="(item, index) in imgUploadList" :key="item.name" class="list-item">
      <img @click="handleImgPreview(index)" :src="item.url" alt="" />
      <Icon @click="handleImgListRemove(index)" class="close-icon" name="clear" />
    </div>
  </div>
</template>
<script>
import '../choice/css/choice.scss'
import { Loading, Icon, Progress, Toast, ImagePreview } from 'vant'
import { getUploadToken } from '@/api/index'
import { getQueryString, compressPng, isImage, isVideo } from '@/utils/tools'
import * as WebUploader from './webupload.js'
import { useStore } from 'vuex'
import Compressor from 'compressorjs'
import { QUES_KEY_225_1, QUES_KEY_225_2 } from '@/constants'
export default {
  components: {
    Loading,
    Icon,
    Progress,
  },
  props: ['info', 'token', 'activeKey', 'orgid', 'quesIndex', 'isImg'],
  emits: ['uploadFinished'],
  data() {
    return {
      showSucc: false,
      showLoading: false,
      title: '',
      uploadList: [],
      imgUploadList: [],
      answerArr: [],
      precent: 0,
      uploadToken: '',
    }
  },
  computed: {
    maxSizeTips() {
      let maxSize = 200

      if (this.$store.getters.getOrgId === '225') {
        maxSize = 500
      } else if (this.$store.getters.getOrgId === '21') {
        maxSize = 300
      }

      return `支持最大单个视频${maxSize}M,单张图片10M.其他类型最大文件20M`
    }
  },
  methods: {
    // 获取最大文件大小
    getMaxFileSize() {
      const orgId = this.$store.getters.getOrgId
      if (orgId === '225') {
        return 1024 * 1024 * 500
      } else if (orgId === '21') {
        return 1024 * 1024 * 300
      }

      return 1024 * 1024 * 200
    },
    // 初始化webload
    async initWebUpload() {
      const questionActiveKey = this.$route.query.questionActiveKey
      const timestamp = new Date().getTime()
      const uploadParam = JSON.stringify({
        group: 'survey',
        uploadId: timestamp,
        pathConfig: 'auto',
        orgid: this.$store.getters.getOrgId || 29,
        dirname: this.info.questionActiveKey,
      })
      const uploadParamEncode = encodeURIComponent(uploadParam)
      const that = this
      const token =
        this.$store.getters.getToken ||
        'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJnaWQiOjAsInQiOjE2NzE2NzYyNzAsIm9wZW5pZCI6IjNzRGpmMkxxWWdJSzd2bE0tR0Z3YXciLCJpc3MiOiJjcSIsIm5pY2tuYW1lIjoi5Lmd5pyI5q2j5b2T5aW9ZXIiLCJhdmF0YXIiOiJodHRwczovL2ltZzExLmlxaWx1LmNvbS9hdmF0YXIvYzcvNGQvMTYucG5nPzE2NDg3MTgwNDUyMzIiLCJ0aW1lIjoxNjcxNjc2MjcwLCJvcmdpZCI6MjksInBsYXRmb3JtIjoiY2h1YW5ncWkifQ.a3YUhh24NUWPv2oYKaBbrjveXp9oGKHqfpOIciPDGiY'

      // 是否是225不需要限制的卷子
      const is255NoLimit =
        questionActiveKey === QUES_KEY_225_1 ||
        questionActiveKey === QUES_KEY_225_2

      let accept = {}
      // 临时这么处理
      if (
        this.$route.query.questionActiveKey ===
        '7c738a828c904d339185bf598d9594c6'
      ) {
        accept = {
          extensions: 'doc,docx,xls,xlsx,ppt,pptx,pdf,txt,zip,rar',
          mimeTypes: 'docx/*',
        }
      }

      // 限制格式, 临时给图书收集两套卷子限制格式
      if (
        this.$route.query.questionActiveKey ===
        '27ff6bb90f184d49be883323957d5e64' ||
        this.$route.query.questionActiveKey ===
        '4b5e7a37dd754e86b0205ce529f99f35'
      ) {
        accept = {
          title: 'Images',
          extensions: 'jpg,jpeg,png',
          mimeTypes: 'image/*',
        }
      }
      const uploader = WebUploader.create({
        // swf文件路径
        swf: '../../assets/js/Uploader.swf',
        // 文件接收服务端。
        server: `https://app.litenews.cn/cq-app-upload/trans/upload/attach/file?token=${token}&uploadParam=${uploadParamEncode}&platform=chuangqi`,
        // server: `https://app.litenews.cn/cq-app-upload/upload/attach/file?token=${token}&uploadParam=${uploadParamEncode}&platform=survey`,
        // server: `http://12345.linyi.gov.cn/cq-app-upload/upload/attach/file?token=${token}&uploadParam=${uploadParamEncode}&platform=survey`,

        // 选择文件的按钮。可选。
        // 内部根据当前运行是创建，可能是input元素，也可能是flash.
        pick: {
          id: `#picker${this.quesIndex}`,
          multiple: false,
        },
        chunked: true,
        fileNumLimit: 2,
        // 如果orgID是225最大500mb，其他200mb
        fileSizeLimit: this.getMaxFileSize(),
        // chunkSize: 1024 * 100,

        resize: false,

        auto: true,
        compress: is255NoLimit
          ? false
          : {
            quality: 70,
          },
        // 只允许选择图片文件。
        accept,
      })

      // 上传前处理
      uploader.on('beforeFileQueued', async function (file) {
        console.log('file', file)
        // png图片需要压缩
        if (file.type === 'image/png') {
          const compressedFile = await compressPng(file.source.source, 0.5);

          file.source.source = compressedFile;
        }
        // 图片的时候需要先判断大小
        if (
          isImage(file.name) ||
          file.type === 'image/jpeg' ||
          file.type === 'image/png'
        ) {
         
          // 临时给图书收集两套卷子放开限制大小
          if (file.size > 1024 * 1024 * 10 && !is255NoLimit) {
            // 抛出错误阻止上传
            Toast('图片上传请在10MB以内')
            return false
          }
        } else if (
          isVideo(file.name) ||
          file.type === 'image/mp4' ||
          file.type === 'image/mov'
        ) {
          const limitSize = that.getMaxFileSize()

          if (file.size > limitSize) {
            // 抛出错误阻止上传
            Toast('视频超过限制大小')
            return false
          }
        } else {
          if (file.size > 1024 * 1024 * 20) {
            Toast('文件上传请在20MB以内')
            return false
          }
        }
      })
      uploader.on('uploadStart', function (file) { })
      uploader.on('uploadProgress', function (file, percentage) {
        that.showLoading = true
        that.precent = parseInt(percentage * 100)
      })

      uploader.on('fileQueued', function name(file) {
        console.log('fileQueued', file)
        uploader.upload(file)
      })

      uploader.on('uploadSuccess', function (file, res) {
        if (!res) {
          return
        }
        if (res.code === 0) {
          Toast(res.errmsg)
        } else {
          that.showLoading = false
          that.title = res.data.name
          if (isImage(res.data.url)) {
            that.imgUploadList.push({
              name: res.data.name,
              url: res.data.url,
            })
          } else {
            that.uploadList.push({
              name: res.data.name,
              url: res.data.url,
            })
          }

          that.handleFormatEmitData()
        }
      })

      uploader.on('uploadError', function (file) {
        Toast.fail('上传失败')
        that.showLoading = false
      })

      uploader.on('uploadComplete', function (file) {
        that.showLoading = false
      })

      // 全部文件上传完毕时触发
      uploader.on('uploadFinished', function () {
        console.log('所有文件上传完毕');
        // 重置上传队列
        uploader.reset();
      });

      /**
       * 错误提示
       */
      uploader.on('error', function (type) {
        if (type === 'Q_EXCEED_SIZE_LIMIT') {
          Toast('文件过大')
        }
      })
    },
    async getToken() {
      const store = useStore()
      const res = await getUploadToken({
        questionActiveKey: getQueryString('questionActiveKey'),
        token: store.getters.getToken,
      })
      this.uploadToken = res.data
      return res.data
      // return 'eyJhbGciOiJIUzI1NiJ9.eyJhcHAiOiJzdXJ2ZXkiLCJ0aW1lIjoiMTYyMzExNzg5OCIsImV4cCI6MTYyMzIwNDI5OCwidXNlcmlkIjoiMCIsImlhdCI6MTYyMzExNzg5OCwib3JnaWQiOiIyOSJ9.vMTVbBNCT66LlEMpRvP87m6CPSlSxf3gKNx2zGwRwK8'
      // return res.data
      // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOiJjb21tdW5pdHkiLCJ0aW1lIjoxNTk0ODAwOTk2LCJleHAiOjE1OTQ4NDQxOTYsInVzZXJpZCI6MSwiaWF0IjoxNTk0ODAwOTk2LCJvcmdpZCI6IjI5In0.g081jt8TBeisBMJZGaq2wSZSN1EFR_r35C6FqlwS0FQ';
      // return token;
    },
    // emit组装数据
    handleFormatEmitData() {
      const fileList = [...this.uploadList, ...this.imgUploadList]

      const answer = {
        questionKey: this.info.questionKey,
        optionKey: this.info.optionVoList[0].optionKey,
        questionType: this.info.questionType,
        value: JSON.stringify(fileList),
        type: 'input',
      }
      // const question = {
      //   questionKey: this.info.questionKey,
      //   answers: this.answerArr
      // }
      this.$emit('uploadFinished', answer)
    },
    // 删除图片
    handleImgListRemove(index) {
      this.imgUploadList.splice(index, 1)
      this.handleFormatEmitData()
    },
    // 删除文件
    handleFileListRemove(index) {
      this.uploadList.splice(index, 1)
      this.handleFormatEmitData()
    },
    // 预览图片
    handleImgPreview(index) {
      ImagePreview({
        images: this.imgUploadList.map((item) => item.url),
        startPosition: index,
      })
    },
  },
  mounted() {
    // this.getToken()
    this.initWebUpload()
  },
}
</script>

<style lang="scss" scoped>
.tips {
  font-size: 32px;
  color: #999;
  font-weight: 400;
  margin-left: 15px;
}

.upload-wrap {
  display: block;
  margin: 0 auto;
  height: 100%;
  width: 100%;
}

.upload-tips {
  margin: 20px 30px;
  color: tomato;
  font-size: 26px;
  line-height: 1.4;
}

.progress {
  margin: 40px auto;
  width: 700px;
}

.wrap-content {
  display: flex;
  align-items: center;
  height: 100px;
  color: #999;

  img {
    margin-right: 15px;
    width: 46px;
    height: 40px;
  }

  .picker {
    width: 100%;

    :last-child {
      width: 100% !important;
      height: 100% !important;
      opacity: 0;
    }
  }
}

.upload-success {
  position: relative;
  box-sizing: border-box;
  margin-top: 20px;
  display: flex;
  align-items: center;
  padding: 15px;
  font-size: 32px;
  color: #333;
  border: 1px solid #e0e0e0;

  .success-text {
    margin-left: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .close-icon {
    position: absolute;
    right: 10px;
  }
}

.required {
  position: relative;

  &::after {
    content: '*';
    color: red;
    position: absolute;
    top: 0;
    left: -20px;
  }
}

.preview-list {
  display: grid;
  margin: 20px 30px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;

  .list-item {
    position: relative;

    .close-icon {
      position: absolute;
      top: 4px;
      right: 4px;
      color: red;
      background-color: #ffffff;
      border-radius: 50%;
      font-size: 38px;
    }

    img {
      width: 100%;
      height: 200px;
      object-fit: cover;
      border-radius: 10px;
    }
  }
}

@media (min-width: 1200px) {
  .preview-list {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;

    .list-item {
      img {
        width: 480px;
        height: 480px;
      }
    }
  }
}
</style>
